import { sum } from 'lodash';
import { roundPixelToNearestGridPoint, roundPixelToNextGridPoint } from '../../../../../utils/grid/gridUtils';
import { TABLE_CELL_MIN_WIDTH } from '../../../../../../common/table/tableConstants';

/**
 * Return column width changes with adjusted widths:
 * - Round widths
 * - Ensure that widths are not below minimum table cell width
 * - Adjust the last resized target column width, so that the total table width to aligns to Milanote's grid.
 */
export const getColumnWidthChangesAdjustedToGrid = (
    columnWidthsPx: number[],
    targetResizeColumns: number[],
    gridSize: number,
    options: { minTableCellWidthPx?: number; snapToNextGrid?: boolean } = {},
): { column: number; widthPx: number }[] => {
    const { minTableCellWidthPx = TABLE_CELL_MIN_WIDTH * gridSize, snapToNextGrid = false } = options;

    const adjustedColWidthsPx = [...columnWidthsPx];

    const deltaTargetColumn = Math.max(...targetResizeColumns);

    return targetResizeColumns.map((column) => {
        const widthPx = columnWidthsPx[column];
        adjustedColWidthsPx[column] = Math.max(Math.round(widthPx), minTableCellWidthPx);

        if (column === deltaTargetColumn) {
            const totalWidthPx = sum(adjustedColWidthsPx);

            const roundPixelToGridPoint = snapToNextGrid ? roundPixelToNextGridPoint : roundPixelToNearestGridPoint;
            const delta = roundPixelToGridPoint(totalWidthPx + 2, gridSize) - totalWidthPx - 2;

            adjustedColWidthsPx[column] += delta;
        }

        return { column, widthPx: adjustedColWidthsPx[column] };
    });
};
